module.exports = __webpack_public_path__ + "static/media/P.afcd3416.png";